import { ChangeEvent, FC, useLayoutEffect, useMemo, useReducer, useState } from 'react';
import { Field, Form, Label } from '../../Registration.styles';
import { Dropdown, Input, Loading } from '../../../../components';
import { RegistrationFormPage } from '../../templates';
import { newBrandFormReducer, newBrandFormInitialState } from './newBrand.form';
import { Option } from '../../../../components/dropdown/Dropdown';
import { isFormValid } from '../../../../utils';
import { useToastStore } from '../../../../stores';

const NewBrand: FC = () => {
	const { setToast } = useToastStore();
	const [loading, setLoading] = useState<boolean>(false);
	const [tiposDeVeiculo, setTiposDeVeiculo] = useState<Option[]>([]);
	const [state, dispatch] = useReducer(newBrandFormReducer, newBrandFormInitialState);
	const tipoDeVeiculoSelecionado = useMemo(
		() => tiposDeVeiculo.find((veiculo) => veiculo.value === state.idVeiculoTipo),
		[state.idVeiculoTipo, tiposDeVeiculo]
	);

	const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
		const { name, value } = e.target;
		dispatch({ type: 'SET_VALUE', field: name, payload: value });
	};

	const handleSelectOption = (field: string, option: Option) => {
		dispatch({ type: 'SET_SELECT_OPTION', field: field, value: option.value });
	};

	const handleSubmit = () => {
		if (!isFormValid(state)) {
			setToast({ message: 'Preencha todos os campos', variant: 'error' });
			return;
		}

	};

	useLayoutEffect(() => {
		const fetchTipos = async () => {
			setLoading(true);

			try {
				setTiposDeVeiculo([
					{ value: 1, label: 'Carro' },
					{ value: 2, label: 'Moto' },
					{ value: 3, label: 'Caminhão/Ônibus' },
				]);
			} catch {
			} finally {
				setTimeout(() => setLoading(false), 500);
			}
		};

		fetchTipos();
	}, []);

	if (loading) return <Loading fullScreen />;

	return (
		<RegistrationFormPage title='Cadastrar Marca' onSubmit={handleSubmit}>
			<Form>
				<Label>Tipo</Label>
				<Field>
					<Dropdown
						options={tiposDeVeiculo}
						selected={tipoDeVeiculoSelecionado}
						onSelect={(option: Option) => handleSelectOption('idVeiculoTipo', option)}
					/>
				</Field>
				<Label>Descrição</Label>
				<Field>
					<Input
						variant='text'
						value={state.descricao}
						onChange={handleInputChange}
						name='descricao'
					/>
				</Field>
				<Label>Código FIPE</Label>
				<Field>
					<Input
						variant='text'
						value={state.codigoMarcaFipe}
						onChange={handleInputChange}
						name='codigoMarcaFipe'
					/>
				</Field>
			</Form>
		</RegistrationFormPage>
	);
};

export default NewBrand;
